export const NATIONAL_NUMBER_RULE = Object.freeze({
    /*
     * Greece. Closed numbering plan: every subscriber NSN is 10 digits (geographic 2x, mobile 69x /
     * 685–689, and the non-geographic 10-digit ranges); there is NO national trunk prefix — the
     * digits dialled inside Greece are the NSN itself (`+30 21 1333 1391` ↔ `2113331391`).
     * Source: EETT (Hellenic Telecommunications & Post Commission), "Presentation of national ITU-T
     * E.164 numbering plan for country code +30", ITU-T Operational Bulletin communications of
     * 9.IX.2021 and 17.IX.2021 (https://www.itu.int/dms_pub/itu-t/oth/02/02/T02020000550002PDFE.pdf):
     * "The maximum number length (excluding the country code) is 10 digits".
     */
    GR: Object.freeze({
        callingCode: "30",
        nationalSignificantLength: 10,
        trunkPrefix: "",
        source: "EETT national ITU-T E.164 numbering plan for +30, ITU-T communications of 9.IX.2021 and 17.IX.2021",
        readAt: "2026-09-29",
    }),
});
/** The countries a trunk may name as `national_country`. */
export const NATIONAL_RULE_COUNTRY = Object.freeze(Object.keys(NATIONAL_NUMBER_RULE));
/** The reviewed rule for `country`, or `undefined` when there is none (the country cannot be chosen). */
export function nationalNumberRuleOf(country) {
    return Object.hasOwn(NATIONAL_NUMBER_RULE, country) ? NATIONAL_NUMBER_RULE[country] : undefined;
}
//# sourceMappingURL=national-number-rule.js.map